import { useMutation, useQueryClient } from "react-query";

import { getAppointmentsV2QueryKeyPrefix } from "api/services/appointment/hooks/useGetAppointmentsV2";
import { getAppointmentsV2PatientQueryKeyPrefix } from "api/services/appointment/hooks/useGetAppointmentsV2Patient";
import type { AppointmentV1 } from "api/services/appointment/schemas/appointment_v1";
import { useApiClient } from "api/useApiClient";

export const usePutAppointmentCompleted = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<AppointmentV1, Error, number>({
    mutationFn: appointmentID => client.putAppointmentCompleted(appointmentID),
    onSuccess() {
      queryClient.invalidateQueries([getAppointmentsV2QueryKeyPrefix]);
      queryClient.invalidateQueries([getAppointmentsV2PatientQueryKeyPrefix]);
    },
  });
};
